// extracted by mini-css-extract-plugin
export default {"searchBox":"Search_searchBox__CEn+r","inputSearch":"Search_inputSearch__0KQXN"};